<template>
  <table class="table">
    <thead v-if="showHeaders">
      <tr>
        <th scope="col">
          Name
        </th>
        <th scope="col">
          Info
        </th>
        <th scope="col">
          &nbsp;
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(user, index) in users" :key="`user_${user.uuid}_${index}`">
        <td>{{ user.name }}</td>
        <td>
          <span class="kt-badge kt-badge--warning kt-badge--inline kt-badge--pill kt-badge--rounded">
            <span v-if="user.is_super_admin"><i class="fa fa-star" /> Super Admin</span>
            <span v-else-if="user.is_organisation_admin"><i class="fa fa-star" /> Org Admin</span>
            <span v-else-if="user.is_admin"><i class="fa fa-star" /> Admin</span>
            <span v-else><i class="fa fa-lock" /> Standard</span>
          </span>
          <span v-if="user.status" class="kt-badge kt-badge--success kt-badge--inline kt-badge--pill kt-badge--rounded">Enabled</span>
          <span v-else class="kt-badge kt-badge--danger kt-badge--inline kt-badge--pill kt-badge--rounded">Disabled</span>
        </td>
        <td>
          <div v-if="authUser.is_admin" class="dropdown">
            <a :href="editUserUrl(user)" class="btn btn-ss">Edit</a>
          </div>
          <div v-else>
            -
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import UserCardMixin from "VueMixins/UserCardMixin";

export default {
  mixins: [UserCardMixin],
  props: {
    authUser: {
      type: Object,
      required: true,
    },
    users: {
      type: Array,
      required: true,
    },
    showHeaders: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.table > tbody > tr > td {
  vertical-align: middle;
}

table td {
  border-top: 1px dashed #cccccc;
}

</style>
